import { jsx, Fragment } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { config } from '../../tools/config.js';

const DEFAULT_SELECTOR = `#${config.appOverlayId}`;
function Portal(props) {
    const { selector = DEFAULT_SELECTOR, children } = props;
    const [isMounted, setMounted] = useState(false);
    useEffect(() => {
        // prevent HTML mismatch between server and client
        setMounted(true);
    }, []);
    if (!isMounted)
        return null;
    return createPortal(jsx(Fragment, { children: children }), document.querySelector(selector));
}

export { Portal };
